export const types = [{
  value: 1,
  name: 'Type 1'
}, {
  value: 2,
  name: 'Type 2'
}, {
  value: 3,
  name: 'Type 3'
}]

export const MONTHLY_TYPE = 1;
export const ROLE_USER = 0;
export const ROLE_ADMIN = 1;